var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2452 4.20141L11.2461 4.2023L13.6013 6.52461C13.7721 6.69308 13.6655 6.99976 13.3947 6.99976H8.82387H4.70789C4.43936 6.99976 4.33408 6.68956 4.50136 6.52461L4.15029 6.16859L4.50136 6.52461L8.30185 2.77708C8.71598 2.36872 9.39335 2.36858 9.80767 2.77665C9.80782 2.77679 9.80797 2.77694 9.80811 2.77708L11.2452 4.20141Z",
    fill: "#AEB1D2",
    stroke: "#AEB1D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9001 11.8314L11.545 14.1537L10.1069 15.5789C9.49797 16.1794 8.5075 16.1794 7.89854 15.5789L4.09805 11.8314C3.59914 11.3395 3.95865 10.5002 4.65565 10.5002H8.77162H13.3425C14.0468 10.5002 14.399 11.3395 13.9001 11.8314Z",
    fill: "#AEB1D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.a0202d1237c0b64e9b1e3c6df6ec2cbd.svg";
export { ForwardRef as ReactComponent };